import type { Environnements } from '@/features/application/shared/Environnements.types'

// Pages de test pour dev/int
const pagesTest = [
  {
    path: '/tests',
    name: 'tests',
    component: () => import('@/views/tests/TestsView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/debug',
    name: 'debug',
    component: () => import('@/views/tests/DropdownDebugView.vue'),
  },
  {
    path: '/tableau',
    name: 'tableau',
    component: () => import('@/views/tests/TableauView.vue'),
  },
  {
    path: '/sort',
    name: 'sort',
    component: () => import('@/views/tests/TestSortView.vue'),
  },
  {
    path: `/pagination`,
    name: 'pagination',
    component: () => import('@/views/tests/PaginationView.vue'),
  },
  {
    path: '/sablier',
    name: 'testSablier',
    component: () => import('@/views/tests/TestSablier.vue'),
  },
  {
    path: '/input-date',
    name: 'input-date',
    component: () => import('@/views/tests/InputDateView.vue'),
  },
  {
    path: '/autocomplete',
    name: 'autocomplete',
    component: () => import('@/views/tests/BasicAutocompleteView.vue'),
  },
  {
    path: '/test-toggle-switch',
    name: 'test-toggle-switch',
    component: () => import('@/views/tests/TestToggleSwitch.vue'),
  },
  {
    path: '/icons',
    name: 'icons',
    component: () => import('@/views/tests/IconsView.vue'),
  },
  {
    path: '/lock-input',
    name: 'lock-input',
    component: () => import('@/views/tests/LockInputView.vue'),
  },
]

const currentEnv = import.meta.env.VITE_ENV as Environnements

export const routesPagesTests = ['dev', 'int', 'rec02', 'rec01'].includes(currentEnv) ? pagesTest : []
